/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { daysFromNow } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';
import { Price } from '@zapier/currency';

import { buildUpgradeUrl } from './utils';
import type { Result } from '../useAlertBanner/alertBannerNotificationsQuery';

import { BannerProps } from './types';

export const shouldRender = (data: Result['data']) => {
  const { currentAccount } = data;
  const { isTrialing, trialEndDate } = currentAccount;
  return (
    !isTrialing &&
    !!trialEndDate &&
    currentAccount.plan.amount === 0 &&
    daysFromNow(trialEndDate) <= 14
  );
};

export const Component = function ProfessionalTrialEnded(props: BannerProps) {
  const { data, currency } = props;
  const { currentAccount } = data;
  const upgradeUrl = buildUpgradeUrl({
    currentPlanName: currentAccount.plan.name,
    upgradePlanName: data.nextPlan?.name,
    interval: currentAccount.plan.interval,
  });
  // @ref ul-1: Divide by 12 since `nextPlan` should always be annual.
  const nextPlanAmount = (data.nextPlan?.amount || 0) / 12;
  const pricingText = nextPlanAmount > 0 && (
    <span>
      for as low as <Price currency={currency}>{nextPlanAmount}</Price>/month
    </span>
  );

  const onUpgrade = () => {
    props.trackEvent('Trial: clicked banner', {
      in_trial: false,
    });
  };

  return (
    <Alert
      layout={props.layout}
      title="Your Professional trial has ended"
      type="info"
    >
      <Link href={upgradeUrl} onClick={onUpgrade}>
        Upgrade
      </Link>
      {/* Use `&nbsp;` to prevent text wrapping from making "Upgrade" a widow/orphan */}
      &nbsp;{pricingText} to keep using multi-step Zaps, filters, premium apps,
      and more
    </Alert>
  );
};
